"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setEnvironmentCallback = exports.getEnvironmentSetting = exports.determineEnvironment = exports.EnvironmentType = void 0;

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var EnvironmentType;
exports.EnvironmentType = EnvironmentType;

(function (EnvironmentType) {
  EnvironmentType["localhost"] = "localhost";
  EnvironmentType["PPE"] = "PPE";
  EnvironmentType["TIP"] = "TIP";
  EnvironmentType["PROD"] = "PROD";
  EnvironmentType["AR"] = "US";
  EnvironmentType["USSEC"] = "microsoft.scloud";
  EnvironmentType["USNAT"] = "eaglex.ic.gov";
})(EnvironmentType || (exports.EnvironmentType = EnvironmentType = {}));

var determineEnvironment = function determineEnvironment(location) {
  if (environmentCallback !== undefined) {
    var environmentOverride = environmentCallback(location);

    if (environmentOverride !== undefined) {
      return environmentOverride;
    }
  }

  var currentUrl = location.hostname.toLowerCase();

  if ((0, _includes.default)(currentUrl).call(currentUrl, EnvironmentType.localhost.toString().toLowerCase())) {
    return EnvironmentType.localhost;
  } else if ((0, _includes.default)(currentUrl).call(currentUrl, EnvironmentType.PPE.toString().toLowerCase())) {
    return EnvironmentType.PPE;
  } else if ((0, _includes.default)(currentUrl).call(currentUrl, EnvironmentType.TIP.toString().toLowerCase())) {
    return EnvironmentType.TIP;
  } else if ((0, _includes.default)(currentUrl).call(currentUrl, EnvironmentType.AR.toString().toLowerCase())) {
    return EnvironmentType.AR;
  } else if ((0, _endsWith.default)(currentUrl).call(currentUrl, EnvironmentType.USSEC.toString().toLowerCase())) {
    return EnvironmentType.USSEC;
  } else if ((0, _endsWith.default)(currentUrl).call(currentUrl, EnvironmentType.USNAT.toString().toLowerCase())) {
    return EnvironmentType.USNAT;
  } else {
    // Assume that if the URL doesn't contain localhost, TIP, or PPE then it's PROD
    return EnvironmentType.PROD;
  }
};

exports.determineEnvironment = determineEnvironment;

var getEnvironmentSetting = function getEnvironmentSetting(env, fallback, prodSetting, ppeSetting, tipSetting, localhostSetting, arSetting, ussecSetting, usnatSetting, overrideSetting) {
  if (overrideSetting) {
    return overrideSetting;
  }

  if (env === EnvironmentType.localhost && localhostSetting) {
    return localhostSetting;
  }

  if ((env === EnvironmentType.PPE || env === EnvironmentType.localhost) && ppeSetting) {
    return ppeSetting;
  }

  if (env === EnvironmentType.TIP && tipSetting) {
    return tipSetting;
  }

  if (env === EnvironmentType.AR && arSetting) {
    return arSetting;
  }

  if (env === EnvironmentType.USSEC && ussecSetting) {
    return ussecSetting;
  }

  if (env === EnvironmentType.USNAT && usnatSetting) {
    return usnatSetting;
  } // Currently the prod setting also acts the fallback in the .env file


  if (prodSetting) {
    return prodSetting;
  }

  return fallback;
};

exports.getEnvironmentSetting = getEnvironmentSetting;
var environmentCallback = undefined;

var setEnvironmentCallback = function setEnvironmentCallback(callback) {
  environmentCallback = callback;
};

exports.setEnvironmentCallback = setEnvironmentCallback;